import i18n from '../../../lang/index'
console.log(i18n)
export const rules = {
    code: [
        { required: true, message: i18n.t('goodsManIndex.inputCode'), trigger: 'blur' },
        // { type: 'number', message: i18n.t('goodsManIndex.codeMustFigure')}
    ],
    name: [
        { required: true, message: i18n.t('goodsManIndex.inputName'), trigger: 'blur' },
    ],
    specification: [
        { required: true, message: i18n.t('goodsManIndex.inputSize'), trigger: 'blur' },
    ],
    model: [
        { required: true, message: i18n.t('goodsManIndex.inputModel'), trigger: 'blur' },
    ],
    price: [
        { required: true, message: i18n.t('goodsManIndex.inputPrice'), trigger: 'blur' },
        { type: 'number', message: i18n.t('goodsManIndex.priceMustFigure')}
    ],
    priceUnit: [
        { required: true, message: i18n.t('goodsManIndex.choPriceInit'), trigger: 'change' }
    ],
    language: [
        { required: true, message: i18n.t('goodsManIndex.choCountryLan'), trigger: 'change' }
    ],
}
